
export * from "../node_modules/vue3-google-map/dist/es/index.js"